/** IANA zone for Egypt. Browser-only signal; never sent to the server or stored. */
const EGYPT_TIME_ZONE = "Africa/Cairo";

/**
 * True when the browser reports an Egyptian timezone. Used only to show a
 * gentle card tip: Egyptian EGP debit cards often block USD / international
 * online charges, and Lemon Squeezy cancels those silently. A wrong guess
 * (travelling buyer, VPN) costs one muted line, so any failure means "no".
 */
export const isLikelyEgyptBuyer = (): boolean => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone === EGYPT_TIME_ZONE;
  } catch {
    return false;
  }
};
